import { getEndpoint, getHeaders } from '../../../helpers/endpoint';
import map from "lodash/map";

export const REQUEST_FETCH_STATS_PLATFORMS = 'REQUEST_FETCH_STATS_PLATFORMS';
export const SUCCESS_FETCH_STATS_PLATFORMS = 'SUCCESS_FETCH_STATS_PLATFORMS';
export const FAIL_FETCH_STATS_PLATFORMS = 'FAIL_FETCH_STATS_PLATFORMS';

export const fetchStatsPlatforms = (payload, onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_FETCH_STATS_PLATFORMS, payload });
        if (onRequest) onRequest(payload);

        fetch(getEndpoint('fetchStatsPlatforms', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
                if(data.error) dispatch({ type: FAIL_FETCH_STATS_PLATFORMS });
                else {
                    const users = data.usersConnections;
                    const usersConnections = map({ ...users }, (stat, key) => {
                        return { ...stat, id: `usersConnections-${key}`, date: key }
                    });
                    dispatch({ type: SUCCESS_FETCH_STATS_PLATFORMS, data: { ...data, usersConnections } });
                }

                if (onSuccess) onSuccess(data, payload);
            })
            .catch((error, type = FAIL_FETCH_STATS_PLATFORMS) => {
                if (onFail) onFail(type, error);
                dispatch({ type, error });
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/platforms.js